import { ReducedUserType } from 'types/user';
import api from './api';

export interface LoginResponseRequestType {
  associatedCompanyRoles: string[];
  token: string;
  user: ReducedUserType;
}

interface TokenAuthenticationType {
  accessToken: string;
  isCompany: boolean;
}

interface LinkedinAuthenticationType {
  state: string;
  code: string;
  isCompany: boolean;
}

export class AuthService {
  static codeAuthentication = (
    email: string,
    code: string,
    captcha: string
  ) => {
    return api.post<LoginResponseRequestType>('/authentication/signing', {
      email,
      password: code,
      captcha
    });
  };

  static googleAuthentication = ({
    accessToken,
    isCompany
  }: TokenAuthenticationType) => {
    return api.post<LoginResponseRequestType>(
      `/authentication/google/${accessToken}?isCompany=${isCompany}`
    );
  };

  static linkedinAuthentication = ({
    state,
    code,
    isCompany
  }: LinkedinAuthenticationType) => {
    return api.get<LoginResponseRequestType>(
      `/authentication/linkedin?state=${state}&code=${code}&isCompany=${isCompany}`
    );
  };

  static facebookAuthentication = ({
    accessToken,
    isCompany
  }: TokenAuthenticationType) => {
    return api.post(
      `/authentication/facebook-login/${accessToken}?isCompany=${isCompany}`
    );
  };

  static codeGenerate = (
    email: string,
    isCompany: boolean,
    captcha: string
  ) => {
    return api.post('/authentication/code-generate', {
      email,
      isCompany,
      captcha
    });
  };

  static memberAcceptInvite = (token: string) => {
    return api.patch(
      '/member/accept-invite',
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );
  };
}
